import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from '../../../../redux';
import { messages } from './messages';
import {
  DefaultButton,
  SocialButton,
  SocialButtonDefaultExpandedEmail,
  SocialButtonIcon
} from './styled';

export type SocialSignUpButtonProps = {
  readonly href?: string;
  readonly buttonType: string;
  readonly onClick?: () => void;
  readonly className?: string;
  readonly id?: string;
};

function SocialSignUpButton(props: SocialSignUpButtonProps) {
  const { href, buttonType, onClick, id, className } = props;
  const { enableDefaultExpandedEmail } = useAppSelector(
    (state) => state.featureFlags
  );

  let btn;
  switch (buttonType) {
    case 'google':
      {
        enableDefaultExpandedEmail
          ? (btn = (
              <SocialButtonDefaultExpandedEmail
                href={href}
                onClick={onClick}
                id={id}
                className={className}
              >
                <SocialButtonIcon src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.51/static/media/google-logo.c21ca9d1.svg" />{' '}
                <FormattedMessage
                  {...messages.socialSignUpButtonContinueWithGoogle}
                />
              </SocialButtonDefaultExpandedEmail>
            ))
          : (btn = (
              <SocialButton
                href={href}
                onClick={onClick}
                id={id}
                className={className}
              >
                <SocialButtonIcon src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.51/static/media/google-logo.c21ca9d1.svg" />{' '}
                <FormattedMessage
                  {...messages.socialSignUpButtonContinueWithGoogle}
                />
              </SocialButton>
            ));
      }

      break;
    case 'microsoft':
      btn = (
        <SocialButton
          href={href}
          onClick={onClick}
          id={id}
          className={className}
        >
          <SocialButtonIcon src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.154/static/media/microsoft-logo.319d9b9a.svg" />{' '}
          <FormattedMessage
            {...messages.socialSignUpButtonContinueWithMicrosoft}
          />
        </SocialButton>
      );
      break;
    default:
      btn = (
        <DefaultButton onClick={onClick} id={id} className={className}>
          <FormattedMessage {...messages.socialSignUpButtonSignUpWithEmail} />
        </DefaultButton>
      );
      break;
  }

  return btn;
}

export default SocialSignUpButton;
